export const userViewType = {
  user: 'user',
  admin: 'admin',
};

export function GetUserView(pathname) {
  const result = !/(admin)|(instructor)/i.test(pathname);
  return result ? userViewType.user : userViewType.admin;
}
